import { PageLayout } from "components/PageLayout"
import { useAppDispatch, useAppSelector } from "hooks/storeHooks"
import { useEffect, useState } from "react"
import { Outlet, useLocation, useNavigate } from "react-router-dom"
import { BillingGate } from "components/BillingGate"
import { setProductsCategoriesLoading, setSelectedCategories } from "store/product/productSlice"
import { selectUserInfo } from "store/user/userSlice"
import { usePrefetchViewer3DKeys } from "@/features/viewer-3d/api/useViewer3D"
import { usePrefetchTryOnKeys } from "@/features/try-on/api/useTryOnIntegration"
import { useHomeQuery } from "@/features/home/api/useHome"
import { UserStatusTypes } from "types"

export const AuthorizedUserLayout: React.FC = () => {
  const navigate = useNavigate()
  const { username, groups, status: userStatus } = useAppSelector(selectUserInfo)
  usePrefetchViewer3DKeys()
  usePrefetchTryOnKeys()
  const isAdmin = groups.some((group) => group.trim().toLowerCase() === "admin")
  const location = useLocation()
  const [isCheckingAuth, setIsCheckingAuth] = useState(true)
  const dispatch = useAppDispatch()
  const isActivateAccountRoute = location.pathname === "/activate-account"
  const homeQuery = useHomeQuery()

  useEffect(() => {
    if (!username) navigate("/login")
    else if (["/login"].includes(location.pathname)) navigate("/home", { replace: true })

    setIsCheckingAuth(false)
  }, [username, location.pathname, navigate])

  // The sidebar categories are per-merchant server state (GET /admin/home).
  // On error the loading flag still resolves so CategoryAccessLayout can
  // bounce to /home, where the page owns the retry UX.
  useEffect(() => {
    if (homeQuery.data) {
      dispatch(setSelectedCategories(homeQuery.data.onboarding.selectedCategories))
      dispatch(setProductsCategoriesLoading(false))
    } else if (homeQuery.isError) {
      dispatch(setProductsCategoriesLoading(false))
    }
  }, [dispatch, homeQuery.data, homeQuery.isError])

  if (isCheckingAuth) return <div className="flex h-screen w-screen items-center justify-center" />

  const billingGateEnabled =
    Boolean(username) &&
    !isAdmin &&
    userStatus === UserStatusTypes.ACTIVE &&
    !isActivateAccountRoute

  return (
    <PageLayout>
      <BillingGate enabled={billingGateEnabled}>
        <Outlet />
      </BillingGate>
    </PageLayout>
  )
}
